import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

// Platform-aware redirect URL for OAuth and password reset
export const isNative = typeof window !== 'undefined' &&
  window.Capacitor?.isNativePlatform?.()

export const AUTH_REDIRECT_URL = isNative
  ? 'com.press2dn.app://auth/callback'
  : `${window.location.origin}`

// Base URL for Vercel API routes — on native, relative paths resolve to
// capacitor://localhost so we must use the full production URL instead.
export const API_BASE = isNative ? 'https://app.press2dn.com' : ''

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    flowType: 'pkce',
  }
})

// Synchronously read the user from Supabase's localStorage-persisted session.
// Used by AuthContext to hydrate state on first render so the app can paint
// cached UI immediately on resume — without waiting for INITIAL_SESSION.
// Falls back to null if the session is missing, malformed, or its access
// token is past expiry. The next API call validates the token authoritatively.
export function readCachedSupabaseUser() {
  try {
    if (typeof localStorage === 'undefined') return null
    for (let i = 0; i < localStorage.length; i++) {
      const k = localStorage.key(i)
      if (!k || !k.startsWith('sb-') || !k.endsWith('-auth-token')) continue
      const raw = JSON.parse(localStorage.getItem(k) || 'null')
      const session = raw?.currentSession ?? raw
      if (!session?.user) continue
      if (session.expires_at && session.expires_at * 1000 < Date.now() - 60_000) {
        // Past hard expiry; let onAuthStateChange decide.
        return null
      }
      return session.user
    }
  } catch { /* ignore */ }
  return null
}
